export default __webpack_public_path__ + "static/media/bar.49376ff0.svg";